<div class="section-hero">
  <div class="container-fluid">
    <!-- <div class="container"> -->
    <div class="row">
      <div class="gc_tool d-flex">
        <app-open-sidebar></app-open-sidebar>

        <div class="container-fluid">
          <div class="row">
            <div class="col-lg-12 flex">
              <div
                class="col-lg-5 col-md-8 d-flex flex-column align-items-center justify-content-center"
                style="height: fit-content; position: relative;"
              >
                <div class="upload text-center">
                  <div class="arrow">
                    <img
                      src="/assets/images/circle.svg"
                      style="width: 60px; height: 60px"
                    />
                  </div>
                  <div class="mt-3">
                    <h4 style="font-size: 18px">Upload file</h4>
                    <p>or click to browse from my device</p>
                    <img
                      src="/assets/images/compose email/cloud.svg"
                      style="
                        position: relative;
                        left: 48px;
                        width: 28px;
                        height: 22.55px;
                      "
                    />
                    <input
                      class="btn btn-modal-dark hideUpload"
                      type="button"
                      title="Click here to upload document"
                      id="loadFileXml"
                      value="Browse"
                      (click)="fileInput.click()"
                      style="
                        width: 175px;
                        height: 40px;
                        font-size: 16px;
                        background-color: #08ba9c;
                        color: white;
                        font-size: 14px;
                        font-weight: 600;
                        padding-left: 25px;
                      "
                    />
                    <input
                      id="upload"
                      (change)="uploadFileSaveRedirect($event)"
                      data-name="upload-element"
                      #fileInput
                      accept=".txt,.doc,.docx,.pdf,.odt,.rtf,.tex"
                      type="file"
                      style="display: none"
                    />
                  </div>
                  <div
                    class="d-flex align-items-center justify-content-center mt-5 p-2 bg-white flex-wrap"
                  >
                    <button
                      class="buton d-flex align-items-center justify-content-center me-2"
                      (click)="openDropboxChooser()"
                      style="background-color: white"
                    >
                      <img
                        class="img-fluid dr-go me-lg-5 me-md-2"
                        src="assets/images/tool/dropbox.svg"
                        alt="dbox-upload"
                        width="27.54"
                        height="27"
                      />
                      Dropbox
                    </button>
                    <button
                      class="buton d-flex align-items-center justify-content-center mt-3 mt-md-0"
                      (click)="gDriveUpload()"
                      style="background-color: white"
                    >
                      <img
                        class="img-fluid me-lg-4 me-md-2 dr-go"
                        src="assets/images/tool/gdrive-upload.svg"
                        alt="gdrive-upload"
                        width="28.36"
                        height="26"
                      />
                      Google Drive
                    </button>
                  </div>
                  
                <div class="progress-loader-div">
                  <div class="progress-loader" *ngIf="loaderAlert"></div>
                </div>
                </div>
              </div>

              <div class="col-lg-7 col-md-4 scr-1024">
                <div class="col-lg-11 col-md-12 search mt-5">
                  <input
                    type="text"
                    class="form-control custom-placeholder"
                    (focus)="onFocus()"
                    (blur)="onBlur()"
                    id="searcbar"
                    ngDefaultControl
                    [(ngModel)]="searchforopen"
                    [ngModelOptions]="{ standalone: true }"
                    (click)="updateFilteredSuggestions()"
                    style="font-size: 18px"
                  />
                  <div class="searchdiv">
                    <img
                      src="../../assets/images/grammar checker/Group 24790.png"
                    />
                  </div>
                </div>
                <div
                  class="placeholder"
                  [ngClass]="{ visible: isPlaceholderVisible }"
                >
                  Search Your File Here
                </div>
                <!-- Recent Files Section -->
                <div
                  class="mt-5 col-lg-11 col-md-12 c768"
                  style="display: flex"
                >
                  <h3
                    class="mb-4 mt-5"
                    style="font-size: 24px; font-weight: 500; margin-top: 6px"
                  >
                    Recent Files
                  </h3>

                  <div class="d-flex float-right icon mt-5" id="view-icon">
                    <!-- Grid Icon -->
                    <div id="view-icon1" class="me-2">
                      <img
                        id="icon-1"
                        [src]="
                          selectedIcon === 'grid'
                            ? 'assets/images/grammar checker/1 hover.svg'
                            : 'assets/images/grammar checker/1.svg'
                        "
                        (click)="showGrid()"
                        (mouseover)="hoveredIcon = 'grid'"
                        (mouseout)="hoveredIcon = null"
                      />
                    </div>

                    <!-- Lines Icon -->
                    <div id="view-icon2" class="me-3">
                      <img
                        id="icon-2"
                        [src]="
                          selectedIcon === 'lines'
                            ? 'assets/images/grammar checker/2 hover.svg'
                            : 'assets/images/grammar checker/2.svg'
                        "
                        (click)="showLines()"
                        (mouseover)="hoveredIcon = 'lines'"
                        (mouseout)="hoveredIcon = null"
                      />
                    </div>
                  </div>
                </div>
                <div class="height" *ngIf="showGridView">
                  <!-- Display based on conditions -->
                  <div class="col-lg-6 col-md-12" id="forbothfilesdiv">
                    <div
                      style="
                        justify-content: center;
                        align-items: center;
                        text-align: center;
                      "
                    >
                      <div
                        class="justify-content-center align-content-center mt-5"
                        (click)="gotoeditor('any')"
                        id="plus"
                      >
                        <img
                          id="circleplus"
                          style="width: 50px; height: 50px"
                          class="mt-4"
                        />
                      </div>
                      <h6
                        style="margin-bottom: 36px; margin-top: 10%"
                        (click)="gotoeditor('any')"
                        class=""
                      >
                        Open a New Document
                      </h6>
                    </div>
                  </div>

                  <div
                    *ngFor="let row of dataListings | filter : searchforopen"
                  >
                    <div class="col-lg-6 col-md-12 h-auto" id="forbothfilesdiv">
                      <!-- Your existing HTML content --><img
                        id="imageforloop"
                        src="../../assets/images/icons/fileicon.svg"
                        (click)="redirectDocument(row?.doc_url)"
                      />
                      <div>
                        <a
                          id="title-set"
                          (click)="redirectDocument(row?.doc_url)"
                          [title]="row?.doc_title"
                        >
                          {{
                            row.doc_title.length >= 15
                              ? (row.doc_title | slice : 0 : 15) + "..."
                              : row.doc_title
                          }}
                        </a>
                      </div>
                      <br />
                      <div
                        id="fileListMsg1_{{ row?.doc_id }}"
                        (click)="redirectDocument(row?.doc_url)"
                      >
                        <span class="line-clamp doc-data">
                          {{ row.doc_data.slice(0, 90) }}...
                        </span>
                      </div>
                      <div class="d-flex date-icon">
                        <div class="trash me-2" id="plus">
                          <a
                            style="margin-left: 8px"
                            (click)="downloadFile(row?.doc_url)"
                          >
                            <img id="opendownload"
                          /></a>
                        </div>
                        <div class="trash me-lg-3 me-2" id="plus">
                          <img
                            id="dete"
                            (click)="deleteFileAfterConfirm(row?.doc_id)"
                            style="font-size: 22px"
                          />
                        </div>
                        <!-- <p class="float-right ">{{ todayDate }}</p> -->
                        <p class="me-1">
                          {{ row.doc_date | date : "dd MMM yyyy" }}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div
                    *ngIf="
                      all_records.length &&
                      (dataListings | filter : searchforopen).length == 0
                    "
                  >
                    <p
                      style="text-align: center; margin-left: 350px"
                      *ngIf="all_records.length && dataListings.length == 0"
                    >
                      <img src="../../assets/images/new/nofilesave.svg" />
                    </p>
                  </div>
                </div>

                <div class="height" *ngIf="showLineView">
                  <!-- Display based on conditions -->
                  <div
                    class="col-lg-6 col-md-12 d-flex cls-768"
                    id="forbothfilesdiv2"
                    style="width: 263px; height: 46px"
                  >
                    <div
                      style="
                        justify-content: center;
                        align-items: center;
                        text-align: center;
                        display: flex;
                      "
                    >
                      <div id="plus">
                        <img
                          id="circleplus"
                          style="width: 28px; height: 28px"
                          class="mt-3"
                          (click)="gotoeditor('any')"
                        />
                      </div>

                      <h6 (click)="gotoeditor('any')" class="ms-2 mt-3">
                        Open a New Document
                      </h6>
                    </div>
                  </div>

                  <div
                    class="col-lg-6 col-md-12 col-sm-12"
                    id="forbothfilesdiv1none"
                    style="width: 32px"
                  >
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  </div>

                  <div
                    *ngFor="let row of dataListings | filter : searchforopen"
                    class="boxes"
                  >
                    <div
                      class="col-md-12 col-sm-12 h-auto"
                      id="forbothfilesdiv1"
                    >
                      <!-- Your existing HTML content -->
                      <img
                        id="imageforlooplines"
                        src="/assets/images/icon (2).svg"
                        (click)="redirectDocument(row?.doc_url)"
                      />
                      <div>
                        <a
                          id="title-set"
                          (click)="redirectDocument(row?.doc_url)"
                          [title]="row?.doc_title"
                        >
                          <h3 style="font-size: 15px; font-weight: 500">
                            {{
                              row.doc_title.length >= 15
                                ? (row.doc_title | slice : 0 : 15) + "..."
                                : row.doc_title
                            }}
                          </h3>
                        </a>
                      </div>
                      <div class="d-flex mt-3 float-right">
                        <p class="me-1">
                          {{ row.doc_date | date : "dd MMM yyyy" }}
                        </p>
                        <div class="trash me-2" id="plus">
                          <a
                            style="margin-left: 8px"
                            (click)="downloadFile(row?.doc_url)"
                          >
                            <img
                              id="opendownload"
                              style="width: 29.49px; height: 28.49px"
                            />
                          </a>
                        </div>
                        <div class="trash" id="plus">
                          <img
                            id="dete"
                            style="width: 29.49px; height: 28.49px"
                            (click)="deleteFileAfterConfirm(row?.doc_id)"
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    *ngIf="
                      all_records.length &&
                      (dataListings | filter : searchforopen).length == 0
                    "
                  >
                    <p
                      style="text-align: center; margin-left: 350px"
                      *ngIf="all_records.length && dataListings.length == 0"
                    >
                      <img src="../../assets/images/new/nofilesave.svg" />
                    </p>
                  </div>
                </div>

                <!-- code for validation  -->
                <div
                  *ngIf="error"
                  class="backdrop"
                  style="
                    position: fixed;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    background-color: rgba(0, 0, 0, 0.5);
                    z-index: 1000;
                  "
                ></div>

                <div
                  *ngIf="error"
                  class="content-div"
                  style="
                    position: fixed;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    width: 468px;
                    height: 360px;
                    background-color: white;
                    z-index: 9999999999999999;
                    border-radius: 4px;
                    border: 1px solid #e3e3f0;
                  "
                >
                  <div class="text-center" style="margin-top: 9%">
                    <img src="/assets/images/paraphrasing tool/alert.svg" />

                    <div style="width: 323px; height: 64px; margin-left: 77px">
                      <p
                        class="error mt-4"
                        style="
                          font-size: 20px;
                          font-weight: 500;
                          line-height: 33.89px;
                        "
                      >
                        {{ errorAlerts }}
                      </p>
                    </div>

                    <button class="mt-4 butn-alert" (click)="closeErrorDiv()">
                      Ok
                    </button>
                  </div>
                </div>

                <div
                  *ngIf="success"
                  class="backdrop"
                  style="
                    position: fixed;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    background-color: rgba(0, 0, 0, 0.5);
                    z-index: 1000;
                  "
                ></div>

                <div
                  *ngIf="success"
                  class="content-div"
                  style="
                    position: fixed;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    width: 468px;
                    height: 360px;
                    background-color: white;
                    z-index: 9999999999999999999999999;
                    border-radius: 4px;
                    border: 1px solid #e3e3f0;
                  "
                >
                  <div class="text-center" style="margin-top: 9%">
                    <img src="/assets/images/paraphrasing tool/success.svg" />

                    <p
                      class="error mt-4"
                      style="
                        font-size: 28px;
                        font-weight: 500;
                        line-height: 33.89px;
                      "
                    >
                      {{ successAlert }}
                    </p>

                    <button class="mt-4 butn-alert" (click)="closeErrorDiv()">
                      Ok
                    </button>
                  </div>
                </div>

                <!-- code for validation  -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- End of .gc_tool -->
    </div>
    <!-- </div> -->
    <!-- End of .row -->
  </div>
  <!-- End of .container-fluid -->
</div>
<!-- End of .section-hero -->
